<template>
  <div class="videos-box">
    <div class="header u-flex u-col-center u-row-between">
      <i class="el-icon-close" @click.stop="leftback"></i>
    </div>
    <i class="el-icon-close close" style="display: none;" @click="leftback"></i>
    <div class="vodeo u-flex u-col-center u-flex-wrap">
      <video class="index-video" :src="url" muted :autoplay="true" loop :controls="true" :webkit-playsinline="true" playsinline x5-playsinline="true" x-webkit-airplay="true"  preload="auto" crossorigin="anymous" type="video"></video>
    </div>
  </div>
</template>

<script>
  export default {
		data() {
			return {
        url: ''
      }
    },
    created() {
			this.url = this.$route.query.url
		},
    methods: {
      leftback() {
        this.$router.go(-1)
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>